<div class="flex flex-col min-h-screen">
  <app-toolbar />
  <div class="flex-1">
    <router-outlet />
  </div>
  <app-footer />
</div>
